module.exports = __webpack_public_path__ + "img/askme.82abdeed.png";